// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Tuvalu */
const TV = /^(?:(?:7[01]\d|90)\d{4})$/;

export default TV;
